<template>
  <div
    class="relative h-full w-full text-xs"
    v-if="investment.type !== 'PORTFOLIO'"
  >
    <div class="grid" :class="numberOfColumns">
      <div class="ml-4 flex w-full items-center justify-start">
        <status-indicator-component
          :status="investment.status"
          :position="investment.position_status"
          :error="toggle_disabled"
          class="mr-2"
        />
        <ontick-toggle-component
          v-show="investment.status != 'HIDDEN'"
          :class="toggle_disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
          :active="investment.status == 'RUNNING' ? true : false"
          :block="toggle_disabled"
          size="sm"
          @switch="
            $emit('toggleSwitch', {
              investmentId: investment.investment_id,
              investmentStatus: investment.status,
              toogle: (toggle_disabled =
                investment.status === 'RUNNING' ? false : toggle_disabled),
            }),
              selectedParams({ value: typed_volume, item: investment })
          "
        />
        <ontick-form-dropdown
          offset
          content="Outras opções"
          v-tippy="{ arrow: true, theme: 'green' }"
          :position="'left'"
          :optionCard="true"
          :disabledOptionDefault="true"
          :optionInitial="optionDefault"
          :options="optionsSelect"
          :footer="investment.investment_id"
          @optionSelected="optionSelected($event, investment)"
          bg="bg-transparent"
        ></ontick-form-dropdown>
      </div>
      <!-- <div class="td">
        <span class="text-gray-500 dark:text-gray-400">
          #{{ investment.investment_id }}
        </span>
      </div> -->
      <!-- <div class="td">
        <div class="flex items-center space-x-1">
          <product-type-component :type="investment.type" />
          <button
            class="transform text-gray-500 transition-all"
            :class="dropdownIsActive ? '' : 'rotate-180'"
            v-if="investment.type === 'PORTFOLIO'"
            @click="togglePortfolioDropdown"
          >
            <i v-html="$icons.chevron_drop_up"></i>
          </button>
        </div>
      </div> -->
      <div
        class="td w-full !justify-start space-x-1 !pr-0 !text-left font-bold"
        :class="nameColumnSize"
      >
        <img
          :src="investment.partner_badge"
          v-if="investment.partner_badge"
          class="h-4 w-4"
        />
        <p
          class="w-full truncate"
          :content="investment.strategy_name"
          v-tippy="{ arrow: true, theme: 'green' }"
        >
          {{ investment.strategy_name }}
        </p>
      </div>

      <!-- <template v-else> -->
      <div class="td">
        <!-- <span v-if="investment.strategy_symbol === 'PORTFOLIO'"> - </span> -->
        <span class="bg-ontick-blue-900 text-ontick-blue-300 rounded px-2 py-1">
          {{ investment.strategy_symbol }}
        </span>
      </div>
      <div class="td">
        <span class="bg-ontick-teal-600 text-ontick-teal-50 rounded px-2 py-1">
          {{ investment.strategy_timeframe }}
        </span>
      </div>

      <div class="td">
        <span
          v-tippy="{ theme: 'green', arrow: true }"
          :content="positionText(investment.position_status).label"
          :class="{
            'bg-ontick-yellow-600 text-ontick-yellow-900 rounded p-1':
              investment.position_status !== 'Zerado',
          }"
        >
          {{ positionText(investment.position_status).minimal || "-" }}
        </span>
      </div>
      <div class="td">
        <template v-if="investment.strategy_market === 'Equities'">
          <span
            v-if="investment.volume_type === 'FIN_VOLUME'"
            :content="`Quantidade a ser definida na abertura da posição (R$${investment.curr_volume})`"
            v-tippy="{ arrow: true, theme: 'green' }"
          >
            {{ investment.position_volume || "-/-" }}
          </span>

          <span
            v-else-if="investment.volume_type === 'QUANTITY'"
            content="Quantidade de ações (posicionados/parametrizados)"
            v-tippy="{ arrow: true, theme: 'green' }"
          >
            {{ investment.position_volume || "-" }}/{{
              investment.param_volume
            }}
          </span>
        </template>
        <span v-else>
          {{ volume }}
        </span>
      </div>
      <!-- </template> -->

      <div
        class="td flex items-center justify-center space-x-2"
        v-if="activeColumns.includes('Resultado')"
      >
        <div
          v-if="investment.open_pnl && investment.position_status !== 'Zerado'"
          :class="
            investment.open_pnl > 0
              ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
              : 'text-ontick-red-500 rotate-180'
          "
          v-html="$icons.arrow_drop"
        ></div>
        <span class="whitespace-nowrap">
          {{
            investment.position_status === "Zerado"
              ? 0
              : investment.open_pnl | currency
          }}
        </span>
      </div>
      <div
        class="td flex items-center justify-center space-x-2"
        v-if="activeColumns.includes('Acumulado')"
      >
        <div
          v-if="investment.closed_pnl + investment.position_profit"
          :class="
            investment.closed_pnl + investment.position_profit > 0
              ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
              : 'text-ontick-red-500 rotate-180'
          "
          v-html="$icons.arrow_drop"
        ></div>
        <span class="whitespace-nowrap">
          {{ (investment.closed_pnl + investment.position_profit) | currency }}
        </span>
      </div>
      <div
        class="td divide-ontick-carbon-900 flex items-center justify-center divide-x dark:divide-gray-300"
        v-if="activeColumns.includes('Status')"
      >
        <!-- <span
          v-if="investment.type === 'PORTFOLIO'"
          class="font-bold uppercase"
          content="Investimento rodando"
          v-tippy="{ arrow: true, theme: 'green' }"
        >
          Ativo
        </span> -->
        <template>
          <span
            v-if="!status.length"
            class="font-bold uppercase"
            content="Investimento rodando"
            v-tippy="{ arrow: true, theme: 'green' }"
          >
            Ativo
          </span>
          <span
            v-else-if="status.length === 1"
            class="font-bold uppercase"
            :class="status[0].color"
            :content="status[0].tooltip"
            v-tippy="{ arrow: true, theme: 'green' }"
          >
            {{ status[0].name }}
          </span>
          <template v-else-if="status.length > 1">
            <span
              v-for="item in status"
              :key="item.name"
              class="px-2 font-bold uppercase"
              :class="item.color"
              :content="item.tooltip"
              v-tippy="{ arrow: true, theme: 'green' }"
            >
              {{ item.name.charAt(0) }}
            </span>
          </template>
        </template>
      </div>
      <div
        class="td !text-ontick-red-700 dark:!text-ontick-red-600"
        v-if="activeColumns.includes('Perda máx.')"
      >
        <!-- <span
          v-if="investment.type === 'PORTFOLIO'"
          class="text-ontick-carbon-900 dark:text-gray-300"
        >
          -
        </span> -->
        <template v-if="investment.strategy_market === 'Equities'">
          <p
            class="whitespace-nowrap"
            content="Ganho por operação"
            v-tippy="{ arrow: true, theme: 'green' }"
          >
            {{ (investment.max_loss * -1) | currency
            }}<span
              v-if="investment.limit_type === 'PER_TRADE'"
              class="text-xs text-gray-500"
              >/op.</span
            >
          </p>
        </template>
        <template v-else>
          <p class="whitespace-nowrap" v-if="investment.max_daily_loss">
            {{
              investment.max_daily_loss
                ? investment.max_daily_loss
                : "-" | currency
            }}
          </p>
          <p
            v-else
            class="flex items-center space-x-2"
            content="Estratégia sem limite de perda configurado"
            v-tippy="{
              arrow: true,
              theme: 'red',
            }"
          >
            <span>N/D</span>
            <i v-html="$icons.red_alert_sm"></i>
          </p>
        </template>
      </div>
      <div
        class="td !text-ontick-green-700 dark:!text-ontick-green-600"
        v-if="activeColumns.includes('Ganho máx.')"
      >
        <!-- <span
          v-if="investment.type === 'PORTFOLIO'"
          class="text-ontick-carbon-900 dark:text-gray-300"
        >
          -
        </span> -->
        <template v-if="investment.strategy_market === 'Equities'">
          <p
            class="whitespace-nowrap"
            content="Ganho por operação"
            v-tippy="{ arrow: true, theme: 'green' }"
          >
            {{ investment.max_gain | currency
            }}<span
              v-if="investment.limit_type === 'PER_TRADE'"
              class="text-xs text-gray-500"
              >/op.</span
            >
          </p>
        </template>
        <template v-else>
          <p class="whitespace-nowrap" v-if="investment.max_daily_gain">
            {{
              investment.max_daily_gain
                ? investment.max_daily_gain
                : "-" | currency
            }}
          </p>
          <p v-else class="flex items-center">
            <span>N/D</span>
          </p>
        </template>
      </div>
    </div>
    <div v-for="(mask, index) in investment.masks_list" :key="index + _uid">
      <card-mask
        :mask="mask"
        @close="closeMask(investment.investment_id, mask)"
      />
    </div>
  </div>
</template>

<script>
import * as icons from "@/app/assets/icons/investments";
import OntickToggleComponent from "../../../ontick-toggle/ontick-toggle.component.vue";
import statusIndicatorComponent from "../../card-investment/status-indicator.component.vue";
import { mapActions } from "vuex";
import EventBus from "@/app/shared/utils/event_bus.js";
import ProductTypeComponent from "../product-type.component.vue";
import CardMask from "../../card-investment/card-mask/card-mask.component.vue";

export default {
  props: {
    investment: {
      type: Object,
      required: true,
    },
  },

  components: {
    OntickToggleComponent,
    statusIndicatorComponent,
    ProductTypeComponent,
    CardMask,
    CardPortfolioPositionBar,
  },

  data() {
    return {
      toggle_disabled: true,

      typed_volume: this.investment.curr_volume,

      optionDefault: {
        icon: icons.details,
        label: null,
      },
      optionsSelect: [
        { icon: icons.editParams, label: "Parâmetros" },
        { icon: icons.performance, label: "Histórico" },
        {
          icon: icons.removeInvestment,
          label:
            this.investment.status != "HIDDEN" ? "Arquivar" : "Desarquivar",
        },
      ],
      dropdownIsActive: false,
      activeColumns: localStorage.getItem("listModeColumns")
        ? localStorage.getItem("listModeColumns").split(",")
        : null,
    };
  },

  computed: {
    nameColumnSize() {
      return this.activeColumns.length > 6 ? "col-span-1" : "col-span-2";
    },
    numberOfColumns() {
      if (this.activeColumns) {
        if (this.activeColumns.length > 6) {
          return `grid-cols-${this.activeColumns.length + 6}`;
        } else {
          return `grid-cols-${this.activeColumns.length + 7}`;
        }
      } else {
        return "grid-cols-10";
      }
    },
    portfolioPosition() {
      if (
        this.investment.components.every(
          (component) =>
            component.position_status ===
            this.investment.components[0].position_status
        )
      ) {
        return this.investment.components[0].position_status;
      } else {
        return "-";
      }
    },
    portfolioVolume() {
      let volumeArray = [];
      for (const component in this.investment.components) {
        if (component.position_volume) {
          volumeArray.push(component.position_volume);
        }
      }
      if (volumeArray.length) {
        return volumeArray.reduce((acc, curr) => acc + curr);
      } else {
        return "-";
      }
    },
    volume() {
      if (this.investment.type === "PORTFOLIO") {
        return this.portfolioVolume;
      } else if (this.investment.position_volume) {
        return `${this.investment.position_volume}/${this.investment.param_volume}`;
      } else {
        return `-/${this.investment.param_volume}`;
      }
    },
    status() {
      let statuses = [];
      if (this.investment.mask_gain) {
        statuses.push({
          name: "Gain",
          color: "text-ontick-green-700 dark:text-ontick-green-600",
          tooltip: "Limite de ganho atingido",
        });
      }
      if (this.investment.mask_loss) {
        statuses.push({
          name: "Loss",
          color: "text-ontick-red-700 dark:text-ontick-red-600",
          tooltip: "Limite de perda atingido",
        });
      }
      if (this.investment.mask_time) {
        statuses.push({
          name: "Tempo",
          color: "text-ontick-teal-700 dark:text-ontick-teal-600",
          tooltip: "Limite de tempo atingido",
        });
      }
      if (this.investment.mask_limit) {
        statuses.push({
          name: "Limite",
          color: "text-ontick-pink-700 dark:text-ontick-pink-600",
          tooltip: "Limite operacional atingido",
        });
      }
      return statuses;
    },
  },

  methods: {
    ...mapActions({
      selectedParams: "investment/selectedParams",
      removeMask: "investment/removeMask",
    }),
    closeMask(investment_id, mask) {
      this.removeMask({
        investment_id,
        mask,
      });
      if (mask.fixedMask) {
        this.$api
          .post(this.$endpoint.DISMISS_MASK, {
            investment_id: investment_id,
            notification_type: mask.type,
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    positionText(value) {
      if (value == "BUY" || value == "Comprado") {
        return {
          label: "Compra",
          minimal: "C",
        };
      } else if (value == "SELL" || value == "Vendido") {
        return { label: "Venda", minimal: "V" };
      } else {
        return { label: "Zerado" };
      }
    },
    togglePortfolioDropdown() {
      this.dropdownIsActive = !this.dropdownIsActive;
      this.$emit("toggle-portfolio-dropdown", this.investment.investment_id);
    },
    optionSelected(event, investment) {
      const labelList = {
        Parâmetros: () => {
          this.$router.push({
            path: "/investments/" + Number(investment.investment_id) + "/edit",
          });
        },
        Histórico: () => {
          this.$router.push({
            name: "Histórico",
            params: {
              id: Number(investment.investment_id),
              label: investment.strategy_name,
            },
          });
        },
        Arquivar: () => {
          if (investment.status == "STOPPED") {
            this.$api
              .post(this.$endpoint.INVESTMENT_HIDE, {
                investment_id: Number(investment.investment_id),
              })
              .then((response) => {
                this.$swal({
                  title: response.data.msg,
                  icon: "success",
                  icon: "success",
                  iconHtml: this.$icons.swal_success,
                });
                this.getInvestments();

                // this.$emit("reload", { investmentActiveOrHidden: "ACTIVE" });
              });
          } else if (investment.status == "RUNNING") {
            this.$swal({
              title: "Você deve parar o investimento para ocultá-lo",
              icon: "error",
              timer: 8000,
            });
          }
        },
        Desarquivar: () => {
          if (investment.status == "HIDDEN") {
            this.$api
              .post(this.$endpoint.INVESTMENT_SHOW, {
                investment_id: Number(investment.investment_id),
              })
              .then((response) => {
                this.$swal({
                  icon: "success",
                  icon: "success",
                  iconHtml: this.$icons.swal_success,
                  title: response.data.msg,
                });
                // this.$emit("reload", { investmentActiveOrHidden: "HIDDEN" });
                this.getInvestments();
              });
          }
        },
      };
      labelList[event.label]();
    },
  },
  created() {
    EventBus.$on("UPDATE_LIST_COLUMNS", (value) => {
      this.activeColumns = value.split(",");
    });
  },
};
</script>

<style lang="scss" scoped>
.td {
  @apply text-ontick-carbon-900 flex items-center justify-center px-4 py-3 text-center dark:text-gray-300;
}
</style>
